import { render, staticRenderFns } from "./ReportUploadForm.vue?vue&type=template&id=632dc74e&"
import script from "./ReportUploadForm.vue?vue&type=script&lang=js&"
export * from "./ReportUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./ReportUploadForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports